import { useNavigate, useParams } from 'react-router-dom';
import { Chip, Spinner } from '@heroui/react';
import { ChevronLeft } from 'lucide-react';
import { useProject } from '@/api/projects';
import MobileKnowledgeBrowser from '@/components/project/miller/MobileKnowledgeBrowser';
import { PROJECT_STATUS_LABELS, PROJECT_STATUS_CHIP } from './statusMaps';

export default function MobileProjectFiles() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: project, isLoading } = useProject(id!);

  return (
    <div className="flex h-full flex-col" style={{ backgroundColor: 'var(--bg-base)' }}>
      <div
        className="flex shrink-0 items-center gap-2 border-b px-2 py-2"
        style={{ borderColor: 'var(--border)' }}
      >
        <button
          onClick={() => navigate('/projects')}
          aria-label="Back to projects"
          className="flex h-11 w-11 items-center justify-center"
          style={{ color: 'var(--accent)' }}
        >
          <ChevronLeft size={20} />
        </button>
        {isLoading || !project ? (
          <Spinner size="sm" color="primary" />
        ) : (
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <span className="truncate font-ui text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>
                {project.project_name}
              </span>
              <Chip
                size="sm"
                variant="flat"
                color={PROJECT_STATUS_CHIP[project.status] ?? 'default'}
                classNames={{ content: 'text-[9px] font-ui font-bold' }}
              >
                {PROJECT_STATUS_LABELS[project.status] ?? project.status}
              </Chip>
            </div>
            <span className="block truncate font-ui text-[11px]" style={{ color: 'var(--text-muted)' }}>
              {[project.client?.name, project.address].filter(Boolean).join(' · ') || '—'}
            </span>
          </div>
        )}
      </div>
      <div className="min-h-0 flex-1">{id && <MobileKnowledgeBrowser projectId={id} />}</div>
    </div>
  );
}
